import { useEffect, useState } from 'react';
import { getProgressData, type ProgressData } from 'utils/epg';

export const useEpgProgress = (startISO: string, endISO: string): ProgressData => {
  const [progress, setProgress] = useState(() => getProgressData(startISO, endISO));

  useEffect(() => {
    const update = () => setProgress(getProgressData(startISO, endISO));

    const delay = 60_000 - (Date.now() % 60_000);
    let intervalId: number;

    const timeoutId = window.setTimeout(() => {
      update();
      intervalId = window.setInterval(update, 60_000);
    }, delay);

    return () => {
      clearTimeout(timeoutId);
      clearInterval(intervalId);
    };
  }, [startISO, endISO]);

  return progress;
};
